import { useCallback } from "react"
import { ContextualHelperIconButton } from "~/app/contexts/ContextualHelperContext"
import type { SharedPearlContext } from "./types"
import { usePearlContext } from "@oysterhr/pearl"

type PearlTooltipProps = {
  fieldName: SharedPearlContext["focusedField"]
  extraInputs?: SharedPearlContext["pearlExtraInputs"]
  gqlParams?: SharedPearlContext["pearlGqlParams"]
  className?: string
}

/**
 * Pearl 2.0 tooltip shared between:
 * - Hiring FTE flow
 * - Hiring contractor flow
 * - Hiring template flow
 * - Staff view edit forms
 * @example <FormLabel endAdorment={<PearlTooltip fieldName="..." />}>
 */
export const PearlTooltip = ({
  fieldName,
  extraInputs,
  gqlParams,
  className,
}: PearlTooltipProps) => {
  const {
    setFocusedField,
    setShowMobilePearlModal,
    setPearlExtraInputs,
    setPearlGqlParams,
    showTooltipOnDesktop,
  } = usePearlContext<SharedPearlContext>()

  const onClick = useCallback(() => {
    if (!fieldName) return

    setShowMobilePearlModal(true)
    setFocusedField(fieldName)
    setPearlExtraInputs(extraInputs ?? null)
    setPearlGqlParams(gqlParams ?? null)
  }, [
    fieldName,
    setShowMobilePearlModal,
    setFocusedField,
    setPearlExtraInputs,
    extraInputs,
    setPearlGqlParams,
    gqlParams,
  ])

  return (
    <div className={showTooltipOnDesktop ? undefined : "md:hidden"}>
      <ContextualHelperIconButton onClick={onClick} className={className} />
    </div>
  )
}
